<template>
  <div class="header">
    <div
      class="container"
      style="display:flex;justify-content: space-between;
    align-items: center;"
    >
      <!-- rsa -->
      <!-- <img
        src="http://120.46.139.153/favicon.png"
        width="1px"
        style="position: absolute; top: -300px"
      /> -->

      <div class="logo" @click="$router.push('/')"></div>
      <div class="user-info-contianer" v-if="showUserInfo">
        <div class="subTitle">{{ title }}</div>
        <!-- width="200" -->
        <el-popover placement="bottom" trigger="click" ref="popover">
          <div
            slot="reference"
            class="user-info-box"
            v-if="userInfo.type === 'BUSINESS'"
          >
            <img
              style="width: 31px;
        height: 31px;
        border-radius: 50%;"
              src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_user.png"
              alt=""
              srcset=""
            />
            <span v-if="userInfo.name">{{ userInfo.name }}</span>
            <i class="el-icon-caret-bottom" />
          </div>
          <div slot="reference" class="user-info-box" v-else>
            <img
              v-if="userInfo.status === '4'"
              style="border-radius:0"
              src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/vip.png"
              alt=""
            />
            <img
              v-else
              style="width:42px;height:47px;border-radius:0"
              src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/noVip.png"
              alt=""
              srcset=""
            />
            <span>{{ userInfo.name || userInfo.username }}</span>
            <i class="el-icon-caret-bottom" />
          </div>
          <div class="popover-container">
            <div v-if="userInfo.type === 'CONSUMER'" class="consumer-info-box">
              <div class="info-box-info">
                <img
                  v-if="userInfo.status !== '4'"
                  src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/noVip.png"
                  alt=""
                  srcset=""
                />
                <img
                  v-else
                  src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/vip.png"
                  alt=""
                  srcset=""
                />
                <div>
                  <div class="name">{{ userInfo.name }}</div>
                  <div class="phone">手机号：{{ userInfo.username }}</div>
                </div>
              </div>
              <div
                class="info-box-buyMember"
                @click="handlePayMember"
                v-if="userInfo.status !== '4'"
              >
                <i class="btn_icon_vip" />开通年会会员，享超值权益>
              </div>
              <div v-else class="vipEndDate">
                会员到期时间：<span>{{
                  userInfo.vipExpirationTime | parseTime("{y}-{m}-{d} {h}:{i}")
                }}</span>
              </div>
            </div>
            <div v-if="userInfo.type === 'BUSINESS'" class="business-container">
              <div class="user-info-box">
                <img
                  src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_user.png"
                  alt=""
                  srcset=""
                />
                <Icon className="icon_user" style="width:31px;height:31px" />
                <span>{{ userInfo.businessInfo.name }}</span>
              </div>
              <div class="description-title">
                <span>机构描述</span>
                <span class="tip">
                  <i class="icon_warning"></i
                  >如需修改机构信息，请联系平台工作人员
                </span>
              </div>
              <div class="description">
                {{ userInfo.businessInfo.businessDescribe }}
              </div>
            </div>
            <div
              class="logout"
              @click="logout"
              :style="{ borderTop: userInfo.type === 'CONSUMER' && '0' }"
            >
              <img
                src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/tuichu.png"
                alt=""
                srcset=""
              />
              退出登录
            </div>
          </div>
        </el-popover>
        <div
          v-if="userInfo.status !== '4' && userInfo.type !== 'BUSINESS'"
          class="payMember"
          @click="handlePayMember"
        >
          开通会员
        </div>
      </div>
      <div class="slogan" v-else>
        <div>全国人力资源信息数据验证平台</div>
        <span>China Human Resources Information Verification Center</span>
      </div>
      <div class="links">
        <div class="links_icon">
          <i class="icon_gh"></i>
          <i class="icon_cta"></i>
        </div>
        <div class="links_text">
          <div class="ws">中 国 防 伪 行 业 协 会</div>
          <div>全国产品防伪溯源验证公共平台</div>
        </div>
        <!-- <div class="s_item">
          <i class="icon_gh"></i>
          <div>
            <p>中华人民共和国国家市场监督管理总局</p>
            <p>State Administration for Market Regulation</p>
          </div>
        </div>
        <div class="s_item">
          <i class="icon_cta"></i>
          <div>
            <p>中国防伪行业协会</p>
            <p>China Trade Association for Anti-counterfeiting</p>
          </div>
        </div> -->
      </div>
    </div>
    <div v-if="dialogBuy">
      <BuyMember :socket-id="_socketId" @handleClose="closePayMember">
        <div slot="btn" style="text-align:center">
          <Btn
            btnText="支付完成"
            @handleClick="handlePayDone"
            className="primary"
            :width="120"
            style="margin-top:30px"
          /></div
      ></BuyMember>
    </div>
  </div>
</template>

<script>
import { logout } from "@/utils/logout";
import BuyMember from "./BuyMember.vue";
import { getUserInfo } from "@/api/user";
import Btn from "./Btn.vue";
import { webSocketMixin } from "@/utils/mixins.js";

export default {
  mixins: [webSocketMixin],
  components: { BuyMember, Btn },
  data() {
    return {
      showUserInfo: false,
      title: localStorage.getItem("headerTitle"),
      isLogin: false,
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")) || {},
      dialogBuy: false
    };
  },
  created() {
    // 需要显示 用户信息 的路由列表 后期可改成不显示列表
    const pathArr = [
      "personalServicesHome",
      "personal",
      "educational",
      "educationalServicesHome",
      "employer",
      "employerServicesHome",
      "educationalAdmin",
      "employerAdmin"
    ];
    const path = this.$route.path.split("/")[1];
    if (pathArr.includes(path)) this.showUserInfo = true;
    // if(!JSON.parse(sessionStorage.getItem("userInfo"))){
    //   this.logout()
    // }
  },
  methods: {
    logout() {
      logout();
    },
    handlePayMember() {
      if (!this.userInfo.idCard) {
        this.$message.warning("请先进行实名认证");
      } else {
        this._initSocket();
        this._socket.onmessage = e => {
          let { data } = e;
          if (data) {
            data = JSON.parse(data);
            console.log(data);
            const { type, paySuccess, message } = data;
            if (type === 2 && paySuccess) {
              // this.handleResult()
              this.handlePayDone();
            }
          }
        };
        this.dialogBuy = true;
        this.$refs.popover.doClose();
      }
    },
    closePayMember() {
      this.dialogBuy = false;
    },
    handlePayDone() {
      getUserInfo().then(res => {
        if (res.data.c === 200) {
          sessionStorage.setItem("userInfo", JSON.stringify(res.data.d));
          this.userInfo = res.data.d;
          this.dialogBuy = false;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  padding: 35px 0;
  background: #fff;
  .logo {
    width: 227px;
    height: 40px;
    margin-right: 18px;
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/logo.png")
      no-repeat;
    background-size: contain;
    position: relative;
    flex-shrink: 0;
    cursor: pointer;
    &::after {
      content: "";
      border-left: 2px solid #ebebeb;
      height: 28px;
      position: absolute;
      right: -18px;
      top: 10px;
    }
  }
  .slogan {
    flex: 1;
    padding-left: 20px;
    .subTitle {
      font-size: 28px;
    }
    div {
      font-size: 21px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #8d8d8d;
    }
    span {
      font-size: 12px;
      font-family: Futura Bk BT;
      font-weight: normal;
      color: #bfbfbf;
    }
  }
  .user-info-contianer {
    display: flex;
    align-items: center;
    margin-left: 22px;
    margin-right: auto;
    .subTitle {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #8d8d8d;
      margin-right: 30px;
    }

    .user-info-box {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #393939;
      cursor: pointer;
      img {
        width: 42px;
        height: 47px;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
    .payMember {
      background: linear-gradient(43deg, #f06c30, #ff4734, #fe6151);
      border-radius: 8px 6px 8px 0px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      padding: 4px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
  .links {
    color: #1a3671;
    font-size: 12px;
    flex-shrink: 0;
    display: flex;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #8d8d8d;
    .icon_gh {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/gh.png")
        no-repeat;
      background-size: 100% !important;
      display: inline-block;
      width: 28px;
      height: 32px;
      margin-left: 2px;
      margin-right: 9px;
      vertical-align: bottom;
    }
    .icon_cta {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/cta.png")
        no-repeat;
      background-size: 100% !important;
      display: inline-block;
      width: 33px;
      height: 26px;
      margin-right: 14px;
      vertical-align: bottom;
    }
    .links_text {
      line-height: 22px;
      .ws {
        word-spacing: 7.8px;
      }
    }
    // .s_item {
    //   display: flex;
    //   margin-bottom: 6px;
    // }
  }
}
</style>

<style lang="scss">
.popover-container {
  .consumer-info-box {
    display: flex;
    flex-direction: column;
    margin: 10px;
    img {
      width: 42px;
      height: 49px;
      // border-radius: 50%;
      margin-right: 10px;
      margin-right: 21px;
    }
    .info-box-info {
      display: flex;
      align-items: flex-end;
      .name {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #393939;
      }
      .phone {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #8d8d8d;
      }
    }
    .info-box-buyMember {
      background: #f5f5f5;
      border: 1px solid #efefef;
      border-radius: 4px;
      margin-top: 20px;
      padding: 7px 10px;
      cursor: pointer;
      .btn_icon_vip {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/btn_icon_vip.png");
        background-size: cover;
        width: 20px;
        height: 15px;
        display: inline-block;
        margin-right: 4px;
      }
    }
    .vipEndDate {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #8d8d8d;
      // line-height: 30px;
      margin-top: 18px;
      span {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #393939;
      }
    }
  }
  .user-info-box {
    width: 225px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #393939;
    padding: 16px 0;
    img {
      width: 31px;
      height: 31px;
      border-radius: 50%;
      margin-right: 10px;
    }
  }
  .business-container {
    width: 477px;
    .user-info-box {
      width: 100%;
      border-bottom: 1px solid #d9d9d9;
      margin-bottom: 14px;
    }
    .description-title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #393939;
      margin-bottom: 16px;
      .tip {
        font-size: 14px;
        font-family: PingFang SC;
        color: #f99167;
        // display: flex;
        // align-items: center;
        flex: 1;
        .icon_warning {
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_warning.png")
            no-repeat;
          background-size: cover;
          display: inline-block;
          margin-right: 8px;
          width: 16px;
          height: 16px;
          vertical-align: middle;
          position: relative;
          top: -1px;
          margin-left: 10px;
        }
      }
    }
    .description {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #6e6e6e;
      margin-bottom: 20px;
    }
  }
  .logout {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #c3c3c3;
    border-top: 1px solid #d9d9d9;
    box-sizing: border-box;
    padding: 16px 0;
    cursor: pointer;
    img {
      width: 13px;
      height: 14px;
      margin-right: 7px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue